export const childrenPaths = [
  // {
  //   path: "/screeners/:id/results",
  //   name: "Screener Results",
  //   enabledFeatures: ['VUE_FEATURE_SCREENER'],
  //   meta: {
  //     menuTitle: "Results",
  //     title: "Results",
  //     icon: "bhi-home",
  //     requiresAuth: true,
  //     disableLink: true
  //   },
  //   component: () => import("@/views/screeners/ScreenerResults.vue")
  // },

  {
    path: '/courses/add',
    name: 'Create Course',
    hidden: true,
    // enabledFeatures: ['VUE_FEATURE_SCREENER'],
    meta: {
      title: 'Create',
      disableLink: true,
      icon: 'bhi-mortarboard',
      requiresAuth: true,
      // root: true,
    },
    component: () => import('@/views/courses/CourseCreate.vue'),
    // children: childrenPaths
  },
  {
    path: '/courses/:id',
    name: 'Course Details',
    hidden: true,
    // enabledFeatures: ['VUE_FEATURE_SCREENER'],
    meta: {
      // title: 'details',
      icon: 'bhi-mortarboard',
      disableLink: false,
      requiresAuth: true,
      // root: true,
    },
    component: () => import('@/views/courses/CourseDetails.vue'),
    // children: childrenPaths
  },
]

export default [
  {
    path: '/courses/',
    name: 'Courses',
    meta: {
      title: 'Courses BETA',
      menuTitle: 'Courses <sup>BETA</sup>',
      icon: 'bhi-mortarboard',
      requiresAuth: true,
    },
    hideOnRole: [1, 2, 3, 7],
    hideOnRoleAlsoAdmins: true,
    component: () => import('@/views/courses/Courses.vue'),
    children: childrenPaths,
  },
]
